import { Pipe, PipeTransform } from "@angular/core";

export enum TemplateStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

const enumToTranslation: Record<TemplateStatus, string> = {
  [TemplateStatus.ACTIVE]: 'enums.template_status.active',
  [TemplateStatus.INACTIVE]: 'enums.template_status.inactive',
}

@Pipe({name: 'templateFilterStatusTranslationKey'})
export class TemplateFilterStatusTranslationKeyPipe implements PipeTransform {
  transform(value: TemplateStatus): string {
    console.log(value)
    console.log(enumToTranslation[value as TemplateStatus])
    return enumToTranslation[value];
  }
}
